export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  handRaised?: Maybe<Scalars['Boolean']['output']>;
  isMuted?: Maybe<Scalars['Boolean']['output']>;
  membersWhenLeft?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  unmuteAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatParticipantInfo = {
  __typename?: 'ChatParticipantInfo';
  additionalInfo: AdditionalInfo;
  chatId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastDeletedMessageDate?: Maybe<Scalars['DateTime']['output']>;
  lastDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  lastDeliveredMessageId?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lastSeenMessageId?: Maybe<Scalars['String']['output']>;
  participant: Scalars['String']['output'];
};

export enum CommandType {
  AllowUnmute = 'ALLOW_UNMUTE',
  DisallowUnmute = 'DISALLOW_UNMUTE',
  HostAdd = 'HOST_ADD',
  HostRemove = 'HOST_REMOVE',
  LowerHand = 'LOWER_HAND',
  Mute = 'MUTE',
  RaiseHand = 'RAISE_HAND',
  Unmute = 'UNMUTE'
}

export enum ContentType {
  File = 'FILE',
  GroupChatEvent = 'GROUP_CHAT_EVENT',
  GroupCreation = 'GROUP_CREATION',
  NotSet = 'NOT_SET',
  PlainText = 'PLAIN_TEXT'
}

export type FieldError = {
  __typename?: 'FieldError';
  /** error details */
  data: GenericErrorPositiveRangeDatetimeErrorLimitedValueError;
  /** the human readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** path to the problematic field */
  path: Array<Scalars['String']['output']>;
};

export type FileUploadConfig = {
  __typename?: 'FileUploadConfig';
  enabled: Scalars['Boolean']['output'];
  /** Size in bytes. -1 means unlimited */
  maximumFileSize: Scalars['Float']['output'];
};

export type GenericError = {
  __typename?: 'GenericError';
  /** the code of the error */
  key: ValueErrorType;
};

export type GenericErrorPositiveRangeDatetimeErrorLimitedValueError = GenericError | LimitedValueError | PositiveRangeDatetimeError;

export type GenericResult = {
  __typename?: 'GenericResult';
  /** Errors in JSON format */
  errors?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
};

export type GroupMessage = {
  content: Scalars['String']['input'];
  contentType: ContentType;
  messageId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
  sender: Scalars['String']['input'];
};

/** An invitation for a meeting */
export type Invitation = {
  __typename?: 'Invitation';
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['output'];
  /** the number of call out attempts left to try */
  calloutAttemptsLeft: Scalars['Int']['output'];
  /** an invitation email will be sent if provided */
  email?: Maybe<Scalars['String']['output']>;
  /** the ID of the invitation */
  id: Scalars['Int']['output'];
  /** shows if this invitation is auto generated */
  isAutoGenerated: Scalars['Boolean']['output'];
  /** the URL to use for joining the meeting with this invitation */
  joinUrl?: Maybe<Scalars['String']['output']>;
  meeting?: Maybe<Meeting>;
  /** the ID of the meeting this invitation belongs to */
  meetingId: Scalars['Int']['output'];
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['output'];
  /** the name of the participant */
  name?: Maybe<Scalars['String']['output']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['output'];
  type: InvitationType;
  userUri?: Maybe<Scalars['String']['output']>;
  /** the confidential identifier of the invitation */
  uuid: Scalars['String']['output'];
};

export type InvitationList = {
  __typename?: 'InvitationList';
  items: Array<Maybe<Invitation>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvitationMeetingInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the meeting */
  meetingId: Scalars['Int']['input'];
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export enum InvitationType {
  Basic = 'BASIC',
  Host = 'HOST'
}

export type IsTypingInput = {
  room: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

/** Error that indicates a value outside of the limit */
export type LimitedValueError = {
  __typename?: 'LimitedValueError';
  /** the code of the error */
  key: ValueErrorType;
  /** the value of the limit */
  limitValue: Scalars['Int']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  /** allow participants to unmute themselves */
  allowUnmute: Scalars['Boolean']['output'];
  /** description of the meeting */
  description?: Maybe<Scalars['String']['output']>;
  /** the ID of the meeting */
  id: Scalars['Int']['output'];
  invitations: Array<Invitation>;
  /** length */
  length?: Maybe<Scalars['Int']['output']>;
  /** the SSO identifier of the owner */
  owner: Scalars['String']['output'];
  /** PIN code used when accessing the meeting through the IVR */
  pinCode?: Maybe<Scalars['String']['output']>;
  /** the room ID used in the IVR application */
  roomId: Scalars['String']['output'];
  /** the start time of the meeting */
  startTime: Scalars['DateTime']['output'];
  /** short summary of the meeting */
  summary: Scalars['String']['output'];
};

export type MeetingList = {
  __typename?: 'MeetingList';
  items: Array<Maybe<Meeting>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  date: Scalars['DateTime']['output'];
  deleted: Scalars['Int']['output'];
  messageId: Scalars['String']['output'];
  metaInfo?: Maybe<Scalars['JSONString']['output']>;
  receiver: Scalars['String']['output'];
  roomId?: Maybe<Scalars['String']['output']>;
  sender: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates an invitation. */
  createInvitation: SaveResult;
  /** Deletes an invitation. */
  deleteInvitation: Array<FieldError>;
  /** Deletes a meeting. */
  deleteMeeting: Array<FieldError>;
  /** Ends a specific meeting. */
  endMeeting: Array<FieldError>;
  /** Indicate typing */
  indicateTyping: GenericResult;
  /** Join to a group chat */
  joinToGroupChat: GenericResult;
  /** Returns the `$pong` value */
  ping: Scalars['String']['output'];
  /** Creates or updates a meeting. */
  saveMeeting: SaveResult;
  /** Send a message to a specific group */
  sendGroupMessage: GenericResult;
  sendParticipantCommand: GenericResult;
  /** Updates an invitation. */
  updateInvitation: Array<FieldError>;
  updateMessageContent: GenericResult;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateInvitationArgs = {
  invitation: InvitationMeetingInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteInvitationArgs = {
  invitationId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteMeetingArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationEndMeetingArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationIndicateTypingArgs = {
  typingIndicationInput: TypingIndicationInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationJoinToGroupChatArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  participantUri: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationPingArgs = {
  pong: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationSaveMeetingArgs = {
  meeting: SaveMeetingInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationSendGroupMessageArgs = {
  groupMessage: GroupMessage;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationSendParticipantCommandArgs = {
  command: ParticipantCommand;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationUpdateInvitationArgs = {
  invitation: UpdateInvitationInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationUpdateMessageContentArgs = {
  content: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type ParticipantCommand = {
  initiator: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  target: Scalars['String']['input'];
  type: CommandType;
};

/** Error that indicates a date outside of the specified range */
export type PositiveRangeDatetimeError = {
  __typename?: 'PositiveRangeDatetimeError';
  endField: Scalars['String']['output'];
  /** the code of the error */
  key: ValueErrorType;
  startField: Scalars['String']['output'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type Query = {
  __typename?: 'Query';
  /** Returns an invitation list. */
  invitations?: Maybe<InvitationList>;
  /** Returns a meeting list. */
  meetings?: Maybe<MeetingList>;
  /** Returns message list */
  messages: Array<Message>;
  /** Returns the next meeting for the user. */
  nextMeeting?: Maybe<Meeting>;
  /** Returns `pong` if the server is available. */
  ping: Scalars['String']['output'];
  /** Returns the roles of the user. */
  roles: Array<Role>;
  /** Returns server info */
  serverInfo: ServerInfo;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryInvitationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meetingId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notMeetingId?: InputMaybe<Scalars['Int']['input']>;
  notUuid?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMeetingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  hideFuture?: InputMaybe<Scalars['Boolean']['input']>;
  hideStarted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ongoing?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMessagesArgs = {
  roomId?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type SaveInvitationInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the invitation */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export type SaveMeetingInput = {
  /** allow participants to unmute themselves */
  allowUnmute: Scalars['Boolean']['input'];
  /** description of the meeting */
  description?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the meeting */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** invitations to add to the meeting */
  invitations?: Array<SaveInvitationInput>;
  /** the length of the meeting */
  length: Scalars['Int']['input'];
  /** PIN code used when accessing the meeting through the IVR */
  pinCode?: InputMaybe<Scalars['String']['input']>;
  /** the start time of the meeting */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** short summary of the meeting */
  summary: Scalars['String']['input'];
};

export type SaveResult = {
  __typename?: 'SaveResult';
  errors?: Maybe<Array<FieldError>>;
  /** the ID of the saved record, set if the operation was successful */
  id?: Maybe<Scalars['Int']['output']>;
};

export type ServerInfo = {
  __typename?: 'ServerInfo';
  fileUpload: FileUploadConfig;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Yields the participant list of the selected room at every changes */
  chatParticipantInfo: Array<ChatParticipantInfo>;
  /** Returns live data from meeting related invitations. */
  invitations: Array<Invitation>;
  /** Yields the current typing state of a user in a given room. */
  isTyping: Scalars['Boolean']['output'];
  /** Returns live data from a meeting. */
  meeting: Meeting;
  /** Yields the received message. */
  message: Message;
  /** Yields $pong in every 1 sec */
  ping: Scalars['String']['output'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionChatParticipantInfoArgs = {
  roomId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionInvitationsArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionIsTypingArgs = {
  isTypingInput: IsTypingInput;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionMeetingArgs = {
  id: Scalars['Int']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionMessageArgs = {
  roomId?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionPingArgs = {
  pong: Scalars['String']['input'];
};

export type TypingIndicationInput = {
  isTyping: Scalars['Boolean']['input'];
  room: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type UpdateInvitationInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the invitation */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export enum ValueErrorType {
  Email = 'EMAIL',
  FutureDate = 'FUTURE_DATE',
  MeetingNotInFuture = 'MEETING_NOT_IN_FUTURE',
  MeetingNotOngoing = 'MEETING_NOT_ONGOING',
  NotDeletable = 'NOT_DELETABLE',
  NotExists = 'NOT_EXISTS',
  OneOfEmailNamePhoneNumberRequired = 'ONE_OF_EMAIL_NAME_PHONE_NUMBER_REQUIRED',
  PhoneNumber = 'PHONE_NUMBER',
  PinCode = 'PIN_CODE',
  PositiveDateRange = 'POSITIVE_DATE_RANGE',
  PositiveNumber = 'POSITIVE_NUMBER',
  Required = 'REQUIRED',
  StringMinLength = 'STRING_MIN_LENGTH'
}
